import { Component } from '@angular/core';

@Component({
  selector: 'app-overlay-panel',
  templateUrl: './overlay-panel.component.html',
  styleUrls: ['./overlay-panel.component.css']
})
export class OverlayPanelComponent {

  overlayVisivel = false;

  exibir(): void {
    this.overlayVisivel = true;

    setTimeout(() => {
      document.getElementById('overlay-container')
              .classList
              .remove('overlay-container-inativo');
  
      document.getElementById('overlay-container')
              .classList
              .add('overlay-container-ativo');    
    }, 100);

  }

  esconder(): void {
    document.getElementById('overlay-container')
            .classList
            .remove('overlay-container-ativo');

    document.getElementById('overlay-container')
            .classList
            .add('overlay-container-inativo');    

    setTimeout(() => {
      this.overlayVisivel = false;
    }, 500);
  }

}
